import React from "react";
import Image from "next/image";
import Link from "next/link";
import FooterSociallinks from "./FooterSociallinks";
import { FooterData } from "@/data/menu";
import ContentNavList from "@/components/content/ContentNavList";

export default function FooterPreview({ data = FooterData }) {
  const { brand, badges, sections } = data ;

  return (
    <footer className="page-section footer bg-gray-light-1 pb-30">
      <div className="container">
        <div className="row pb-120 pb-sm-80 pb-xs-50">
          {/* Brand Section */}
          {brand && (
            <div className="col-md-4 col-lg-3 text-gray mb-sm-50">

              {/* ✅ Show Highlight Products ONLY if available */}
              {brand.highlightProducts?.length && brand.highlightProducts?.[0].image > 0 ? (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '20px',
                    marginTop: '20px',
                    alignItems: 'center'
                  }}
                >
                  {brand.highlightProducts.map((item, index) => (
                    <a
                      key={index}
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ display: 'block', width: '100%' }}
                    >
                      <Image
                        src={item.image}
                        alt={item.title}
                        width={360}
                        height={216}
                        style={{
                          width: '100%',
                          maxWidth: '360px',
                          height: 'auto',
                          aspectRatio: '360/216',
                          objectFit: 'cover',
                          borderRadius: '6px',
                          border: '1px solid #e5e7eb'
                        }}
                        className="rounded-md border border-gray-300"
                      />
                    </a>

                  ))}
                </div>
              ) : (
                <>

                  {brand.logo && (
                    <Link href={brand.link} className="mb-30">
                      <Image
                        src={brand.logo}
                        width={155}
                        height={50}
                        className="mb-3 rounded"
                        alt={`${brand.name} Logo`}
                      />
                    </Link>
                  )}

                  {/* Show the description, email & badges only if highlightProducts is NOT available */}
                  {brand.description && <p>{brand.description}</p>}

                  {brand.email && (
                    <div className="clearlinks">
                      <strong>Mail:&nbsp;</strong>
                      <a href={`mailto:${brand.email}`} aria-label="Mail">{brand.email}</a>
                    </div>
                  )}

                  {badges?.[0]?.src && badges?.length > 0 && (
                    <div style={{ display: 'flex', gap: '10px', marginTop: '20px', flexWrap: 'wrap' }}>
                      {badges.map((badge, index) => (
                        <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
                          <img src={badge.src} alt={badge.alt} style={{ height: badge.height }} />
                        </div>
                      ))}
                    </div>
                  )}
                </>
              )}

            </div>
          )}


          {/* Sections */}
          <div className="col-md-7 offset-md-1">
            <div className="row mt-n30">
              {sections?.length > 0 &&
                sections.map((section, idx) => (
                  <div className="col-sm-3 mt-30" key={idx}>
                    {section.title && <span className="fw-title">{section.title}</span>}
                    <ul className="fw-menu clearlist">
                      {section.links?.map((link, i) => (
                        <li key={i}>
                          <a
                            href={link.href}
                            target={link.target || "_self"}
                            rel={link.target === "_blank" ? "noopener noreferrer" : undefined}
                            aria-label={link.text}
                          >
                            {link.text}
                          </a>
                        </li>
                      ))}
                      {/* Auto-nav: content-engine pages that opted into this
                          group. Renders nothing if none opted in. */}
                      {section.contentNavGroup && (
                        <ContentNavList group={section.contentNavGroup} />
                      )}
                    </ul>
                  </div>
                ))
              }
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <FooterSociallinks />
      </div>
    </footer>
  );
}
